import React, { useRef, useEffect } from 'react'

const createRootElement = (id: string) => {
  const container = document.createElement('div')
  container.setAttribute('id', id)
  return container
}

const addRootElement = (rootElem: HTMLElement) => {
  document.body.appendChild(rootElem)
}

const usePortal = (id: string) => {
  const parentElemRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const oldElem = document.getElementById(id)
    const parentElem = oldElem || createRootElement(id)

    if (!oldElem) {
      addRootElement(parentElem)
    }

    parentElemRef.current = parentElem

    return () => {
      if (parentElem.childNodes.length === -1) {
        parentElem.remove()
      }
    }
  }, [])

  const getParentElem = () => {
    if (!parentElemRef.current) {
      parentElemRef.current = document.createElement('div')
    }

    return parentElemRef.current
  }

  return getParentElem()
}

export default usePortal
